import React, { useState, useEffect } from 'react';
import FileServices from 'services/FileServices';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const VideoPreview = ({
  videoName,
  thumbnailSrc = '/assets/images/no-header-img.jpg',
  fallbackSrc = '/assets/images/no-header-img.jpg',
  alt = 'Video Preview',
  width = 200,
  height = 200,
  showVideoPlayer = false,
}) => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const loadVideo = async () => {
      try {
        setIsLoading(true);
        console.log("video loading started");
        
        const videoUrl = await FileServices.getIncidentVideo(videoName);
        setVideoUrl(videoUrl);
        setIsLoading(false);
      } catch (err) {
        console.error('Video loading error:', err);
        setError('Failed to load video');
        setIsLoading(false);
      }
    }
    if (videoName) {
      loadVideo();
    }
  }, [videoName]);

  const handleThumbnailClick = () => {
    if (showVideoPlayer) {
      setIsPlaying(!isPlaying);
    }
  }

  const renderThumbnail = () => {
    if (isLoading) {
      return (
        <div>
          <span>Loading...</span>
        </div>
      );
    }
    if (error || !videoUrl) {
      return (
        <img
          src={fallbackSrc}
          alt="Fallback"
          width={width}
          height={height}
          onClick={handleThumbnailClick}
        />
      );
    }
    return (
      <div style={{position: 'relative', width, height}} onClick={handleThumbnailClick}>
        <img src={thumbnailSrc} alt={alt} width={width} height={height} />
        <PlayArrowIcon style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'white', fontSize: '48px'}} />
      </div>
    );
  }

  return (
    <>
      {!isPlaying ? (
        renderThumbnail()
      ) : (
        videoUrl && (
          <video controls width={width} height={height} autoPlay>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      )}
    </>
  );
}

VideoPreview.propTypes = {
  videoName: (props, propName, componentName) => {
    if (!props[propName]) {
      return new Error(`Prop ${propName} is required in ${componentName}`);
    }
    if (typeof props[propName] !== 'string') {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}. Expected string.`);
    }
  }
}

export default VideoPreview;
